import React, { useRef, useEffect } from 'react';

function ExtensionPanel({ panel }) {
  const panelRef = useRef(null);

  useEffect(() => {
    if (panelRef.current) {
      // Only allow a limited set of props from the panel
      const { name, width, height, settings } = panel.toJSON();

      // @ts-expect-error not typed
      panelRef.current.updateProps({
        panel: { name, width, height, settings },
      });
    }
  }, [panel]);

  if (window.isPublishing) {
    return (
      <aha-empty-state>
        <h2 slot='title'>Extension panels are not visible in exports.</h2>
      </aha-empty-state>
    );
  }

  return (
    <div style={{ overflow: 'auto' }}>
      <extension-component
        ref={panelRef}
        data-extension-identifier={panel.extensionIdentifier}
        data-export-name={panel.exportName}
      />
    </div>
  );
}

export default ExtensionPanel;
